'use strict';

import LazyLoad from "vanilla-lazyload";
import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Autoplay,
    Keyboard,
    EffectFade
} from 'swiper/modules';

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#mobile-menu");

    self.init();

}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        self.bodyScrollClass( self );
        self.cloneMainMenu();
        self.swiperHeroInit();
    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        self.$hamburger.on("mousedown", function () {
            self.mobileMenu();
        });

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        self.$body.toggleClass("sideoutarea-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("open") ){

            self.$mobileMenu.removeClass("open");

            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );

        }
        else {

            self.$mobileMenu.addClass("open");

            t = setTimeout( function(){
                $hamburger.addClass("is-active");
            }, 200 );

        }

    },

    cloneMainMenu: function(){

        $("#main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        // Potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        // A kdy mame skryt menu - jeste nez jsme uplne nahore
        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }

    },

    swiperHeroInit: function() {

        var self = this;

        new Swiper( "#js-swiper-hero", {
            modules: [
                Navigation,
                Pagination,
                Autoplay,
                Keyboard,
                EffectFade
            ],
            loop: true,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            },
            on: {
                // LazyLoad swiper images after swiper initialization
                afterInit: function( swiper )  {
                    new LazyLoad({
                        container: swiper.el,
                        cancel_on_exit: false,
                        callback_loaded: function ( img ) {
                            img.parentNode.classList.add("loaded");
                        }
                    });
                }
            }

        } );

    }

};

$(document).ready(function () {
    new J3WTheme();
});

// Tohle tady mame kvuli fancyboxu
// Kdyz to tu neni, fancybox hlasi chybu
// Netusim proc (novy fancybox by to vyresil, ale je placenej)
window.jQuery = window.$ = $;
